<template>
  <div class="stations">
    <div class="label f8">{{ $t("Select Station") }}</div>
    <div class="stationgrid">
      <div class="station" v-for="station in stations" :key="station.id" :class="{ '-conflict': conflictStationIds.includes(station.id) }">
        <UIButton
          :ghost="true"
          @click="$emit('stationAction', station)"
          :class="{
            '-active': isStationSelected(station)
          }"
          :disabled="isStationAlreadyPartOfBooking(station)"
        >{{ station.title }}</UIButton>
        <div
          v-if="isStationAlreadyPartOfBooking(station)"
          class="message alreadyin f7"
        >{{ $t('Already In Reservation') }}</div>
        <div
          class="message conflictmessage f7"
        >{{ $t('Conflict') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIButton from '@/core/shared/components/ui/UIButton';
import conflictDetectorWorker from '@/location/conflict-detector.worker';
import { isEqual } from 'lodash-es';
const conflictDetector = conflictDetectorWorker();

@Component({
  components: {
    UIButton,
  },
  props: {
    startTime: {
      type: String,
      required: true,
    },
    bookings: {
      type: Array,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
    bookingStationTime: {
      type: Object,
      required: true,
    },
    stations: {
      type: Array,
      required: true,
    },
  },
  watch: {
    startTime: 'getConflictStations',
    'bookingStationTime.tier.id': 'getConflictStations',
  },
})
export default class Stations extends Vue {
  conflictStationIds = [];

  created () {
    this.getConflictStations();
  }

  isStationSelected (station) {
    return this.bookingStationTime.station.id === station.id;
  }

  isStationAlreadyPartOfBooking (station) {
    return this.booking.bookingStationTimes.find(bookingStationTime => {
      return this.bookingStationTime !== bookingStationTime && !bookingStationTime._removed && bookingStationTime.station.id === station.id;
    });
  }

  async getConflictStations () {
    const newConflictStationIds = [];
    for (let index = 0; index < this.stations.length; index++) {
      const station = this.stations[index];
      const wouldCauseConflict = await conflictDetector.willStartTimeStationAndTierCauseConflict(this.startTime, station, this.bookingStationTime.tier, this.booking._id, this.bookings);
      if (wouldCauseConflict) newConflictStationIds.push(station.id);
    }
    if (!isEqual(this.conflictStationIds, newConflictStationIds)) this.conflictStationIds = newConflictStationIds;
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.stations {
  & .label {
    margin-bottom: var(--spacingXS);
  }

  & .stationgrid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: var(--spacingXS);
    width: 100%;

    @media (--tablet) {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: var(--spacingSm);
    }

    @media (--desktop) {
      grid-gap: var(--spacingMd);
      grid-template-columns: repeat(3, 1fr);
    }

    & .station {
      & >>> button {
        width: 100%;
        white-space: normal;
      }

      & .message {
        padding-top: 0.2rem;
        text-align: center;
      }

      & .conflictmessage {
        display: block;
        opacity: 0;
        padding-top: 0.2rem;
        color: var(--colorErrorFlat);
        transition: opacity 0.1s ease;
        text-align: center;
        font-style: italic;
      }

      &.-conflict {
        & .conflictmessage {
          opacity: 1;
        }
      }
    }
  }
}

</style>
